import { buildBreadcrumbJsonLd } from '@/components/Breadcrumb/breadcrumbJsonLd';
import { stringifyJsonLd } from '@/utils/jsonLd';
import cx from 'classnames';
import Head from 'next/head';

import ChevronRightIcon from '@material-ui/icons/ChevronRight';

import styles from './Breadcrumb.module.scss';

export type BreadcrumbItem = {
  label: string;
  href?: string;
};

export type BreadcrumbProps = {
  items: BreadcrumbItem[];
  className?: string;
};

export const Breadcrumb = ({ items, className }: BreadcrumbProps) => (
  <>
    <Head>
      <script
        key="breadcrumb-jsonld"
        type="application/ld+json"
        dangerouslySetInnerHTML={{ __html: stringifyJsonLd(buildBreadcrumbJsonLd(items)) }}
      />
    </Head>
    <nav className={cx(styles.breadcrumb, className)} aria-label="Breadcrumb">
      <ol className={styles.list}>
        {items.map((item, index) => {
          const isCurrentPage = index === items.length - 1;

          return (
            <li key={`${index}-${item.label}`} className={styles.item}>
              {item.href && !isCurrentPage ? (
                <a href={item.href} className={styles.link}>
                  {item.label}
                </a>
              ) : (
                <span
                  className={cx(styles.label, { [styles.current]: isCurrentPage })}
                  aria-current={isCurrentPage ? 'page' : undefined}
                >
                  {item.label}
                </span>
              )}
              {!isCurrentPage && <ChevronRightIcon className={styles.chevron} />}
            </li>
          );
        })}
      </ol>
    </nav>
  </>
);

export default Breadcrumb;
